import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import * as reportsActions from '../../actions/Reports';
import LocaleComponent from '../../LocaleComponent';

let typeFieldFlag = {};

class Settings extends LocaleComponent {
  constructor(props) {
    super(props);
    this.state = {
      groupedSettings: {},
      groupedSettingsDetail: {},
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.campaigns) {
      this.load(nextProps);
    }
  }

  componentDidMount() {
    const { campaigns } = this.props;

    if (campaigns.campaigns) {
      this.load(this.props);
    } else {
      const mcId = this.getMcId();

      if (mcId) {
        this.props.getCampaigns(mcId);
        this.props.getStatuses(mcId);
      }

    }
    window.scrollTo(0, 0);
  }

  load(newState) {
    const { campaigns } = newState;
    const { mcid_settings, adgroup_settings, ads, adgroups } = campaigns;
    const groupedSettings = {
      Google: { ADS: 0, SETTINGS: 0, },
      Yahoo: { ADS: 0, SETTINGS: 0, },
      Facebook: { ADS: 0, SETTINGS: 0,},
    };
    const summary = {
      Campaigns: 0,
      AdGroups: 0,
      Ads: 0,
      Keywords: 0,
      'Campaign Settings': 0,
      'Adgroup Settings': 0,
      Extensions: 0,
    };
    const groupedSettingsDetail = {
      Google: { summary: Object.assign({}, summary), list: [] },
      Yahoo: { summary: Object.assign({}, summary), list: [] },
      Facebook: { summary: Object.assign({}, summary), list: [] },
    };
    const targeting = {};
    const targetTypes = {
      ADGROUP: 'ADGROUP TARGETING',
      CAMPAIGN: 'CAMPAIGN TARGETING',
      EXTENSION: 'EXTENSION',
    };

    // TARGETING
    if (mcid_settings) {
      mcid_settings.forEach(item => {
        const target = targeting[item.SettingsLevel] || {};
        if (!target[item.Publisher]) {
          target[item.Publisher] = {};
        }
        if (target[item.Publisher][item.SettingsName]) {
          target[item.Publisher][item.SettingsName].count += item.count;
          if (target[item.Publisher][item.SettingsName].lastChecked < item.last_updated) {
            target[item.Publisher][item.SettingsName].lastChecked = item.last_updated;
          }
        } else {
          target[item.Publisher][item.SettingsName] = {
            count: item.count,
            lastChecked: item.last_updated,
          };
        }

        targeting[item.SettingsLevel] = target;
      });

      Object.keys(targeting).forEach(target => {
        const item = targeting[target];
        Object.keys(item).map(publisher => {
          Object.keys(item[publisher]).map(settingName => {
            if (groupedSettingsDetail[publisher]) {

              groupedSettingsDetail[publisher].list.push({
                Type: targetTypes[target] && target,
                Setting: settingName,
                'Settings Found': item[publisher][settingName].count,
                'Last Checked': item[publisher][settingName].lastChecked,
              });
            }
          });
        });
      });
    }

    // ads
    if (ads) {
      ads.forEach(item => {
        if (item.Status === 'ACTIVE' || item.Status === 'ENABLED') {
          if (groupedSettings[item.Publisher]) {
            groupedSettings[item.Publisher].ADS += 1;
          }
          if (groupedSettingsDetail[item.Publisher]) {
            groupedSettingsDetail[item.Publisher].summary.Ads += 1;
          }
        }
      });
    }

    // Adgroup setting
    if (adgroup_settings) {
      adgroup_settings.forEach(item => {
        if (item.Status === 'ACTIVE' || item.Status === 'ENABLED') {
          if (groupedSettingsDetail[item.Publisher]) {
            groupedSettingsDetail[item.Publisher].summary['Adgroup Settings'] += 1;
          }
        }
      });

      Object.keys(groupedSettingsDetail).forEach(key => {
        groupedSettings[key].SETTINGS += groupedSettingsDetail[key].summary['Adgroup Settings'];
      });
    }

    // campaigns
    if (campaigns.campaigns) {
      const camp = campaigns.campaigns;
      camp.forEach(item => {
        if (item.status === 'ACTIVE' || item.status === 'ENABLED') {
          if (groupedSettingsDetail[item.Publisher]) {
            groupedSettingsDetail[item.Publisher].summary.Campaigns += 1;
          }
        }
      })
    }

    // adgroups
    if (adgroups) {
      adgroups.forEach(item => {
        if (item.Status === 'ACTIVE' || item.Status === 'ENABLED') {
          if (groupedSettingsDetail[item.Publisher]) {
            groupedSettingsDetail[item.Publisher].summary.AdGroups += 1;
          }
        }
      })
    }

    Object.keys(groupedSettingsDetail).forEach(publisher => {
      groupedSettingsDetail[publisher].list.map(item => {
        const settingFilters = {
          DEVICES: 'DEVICE',
          LOCATIONS: 'LOCATION',
          SCHEDULES: 'SCHEDULE',
          NEGATIVES: 'NEGATIVE',
          AGES: 'AGE',
          GENDERS: 'GENDER',
          INTERESTS: 'INTEREST',
          KEYWORDS: 'KEYWORD',
          PLACEMENTS: 'PLACEMENT',
          USERLISTS: 'USERLIST',
          EXTENSIONS: '',
        };
        const settingFilter = settingFilters[item.Setting.toUpperCase()] || item.Setting;
        const mcId = this.getMcId();
        let params = {};
        switch(item.Type) {
          case 'CAMPAIGN':
            params = {
              mcId,
              tab: 'settings',
              publisherFilter: publisher,
              typeFilter: settingFilter,
            };
            item.settingWithLink = {
              setting: item.Setting,
              link: `campaigns${this.stringfy(params)}`,
            };
            break;
          case 'ADGROUP':
            params = {
              mcId,
              tab: 'settings',
              publisherFilter: publisher,
              typeFilter: settingFilter,
            };
            item.settingWithLink = {
              setting: item.Setting,
              link: `adgroups${this.stringfy(params)}`,
            };
            break;
          case 'EXTENSION':
            item.Type = 'FEED';
            params = {
              mcId,
              publisherFilter: publisher,
            };
            item.settingWithLink = {
              setting: item.Setting,
              link: `extensions${this.stringfy(params)}`,
            };
            break;
          default:
            item.settingWithLink = {
              setting: item.Setting,
              link: '#',
            };
        }
      });
    });

    // keywords and negative keywords
    const adgroupTargeting = targeting.ADGROUP || {};
    const campaignTargeting = targeting.CAMPAIGN || {};
    Object.keys(adgroupTargeting).forEach(publisher => {
      if (groupedSettingsDetail[publisher]) {
        const a = adgroupTargeting[publisher] ?
        (adgroupTargeting[publisher].keywords ? adgroupTargeting[publisher].keywords.count : 0) +
        (adgroupTargeting[publisher].negatives ? adgroupTargeting[publisher].negatives.count : 0) : 0;
        const b = campaignTargeting[publisher] ?
          (campaignTargeting[publisher].keywords ? campaignTargeting[publisher].keywords.count : 0) : 0;
        groupedSettingsDetail[publisher].summary.Keywords = a + b;
      }
    });

    this.setState({
      groupedSettings,
      groupedSettingsDetail,
    })
  }

  render() {
    const { groupedSettings, groupedSettingsDetail } = this.state;

    const SettingCard = (props) => {
      const className = {
        Google: {
          div: 'google-plus',
          i: 'fa-google',
          canvas: 'social-box-chart-1',
          iStyle: {},
        },
        Yahoo: {
          div: 'yahoo',
          i: 'fa-yahoo',
          canvas: 'social-box-chart-2',
          iStyle: {color: 'white', backgroundColor: '#4102b0'},
        },
        Facebook: {
          div: 'facebook',
          i: 'fa-facebook',
          canvas: 'social-box-chart-3',
          iStyle: {},
        },
      };

      return (
        <div className={`social-box ${className[props.publisher].div}`}>
          <i className={`fa ${className[props.publisher].i}`} style={className[props.publisher].iStyle} />
          <div className="chart-wrapper">
            <canvas id={className[props.publisher].canvas} height="90" />
          </div>
          <ul>
            <li>
              <strong>{props.ADS}</strong>
              <span>{props.localeMessage('ADS')}</span>
            </li>
            <li>
              <strong>{props.SETTINGS}</strong>
              <span>{props.localeMessage('SETTINGS')}</span>
            </li>
          </ul>
        </div>
      );
    };
    const SettingDetailCard = (props) => {
      typeFieldFlag = {};

      const typeFormatter = (cell) => {
        if (cell !== undefined) {
          if (typeFieldFlag[cell]) {
            return '';
          } else {
            typeFieldFlag[cell] = true;
            return props.localeMessage(cell);
          }
        } else {
          return '';
        }
      };

      const settingFormatter = (cell) => {
        if (cell !== undefined) {
          return props.localeMessage(`<a href='#/${cell.link}'>${cell.setting.toUpperCase()}</a>`);
        } else {
          return '';
        }
      };

      return (
        <div className="card">
          <div className="card-header">
            {props.publisher}
          </div>
          <div className="card-block">
            <div className="row">
              <div className="col-sm-12 col-lg-12">
                <div className="row">

                  <div className="col-sm-2">
                    <div className="callout callout-info">
                      <small className="text-muted">{props.localeMessage('Campaigns')}</small><br/>
                      <strong className="h4">{props.summary.Campaigns}</strong>
                      <div className="chart-wrapper">
                        <canvas id="sparkline-chart-1" width="100" height="30" />
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-2">
                    <div className="callout callout-danger">
                      <small className="text-muted">{props.localeMessage('AdGroups')}</small><br/>
                      <strong className="h4">{props.summary.AdGroups}</strong>
                      <div className="chart-wrapper">
                        <canvas id="sparkline-chart-2" width="100" height="30" />
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-2">
                    <div className="callout callout-warning">
                      <small className="text-muted">{props.localeMessage('Ads')}</small><br/>
                      <strong className="h4">{props.summary.Ads}</strong>
                      <div className="chart-wrapper">
                        <canvas id="sparkline-chart-3" width="100" height="30" />
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-2">
                    <div className="callout callout-info">
                      <small className="text-muted">{props.localeMessage('Keywords')}</small><br/>
                      <strong className="h4">{props.summary.Keywords}</strong>
                      <div className="chart-wrapper">
                        <canvas id="sparkline-chart-4" width="100" height="30" />
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-2">
                    <div className="callout">
                      <small className="text-muted">{props.localeMessage('Campaign Settings')}</small><br/>
                      <strong className="h4">{props.summary['Campaign Settings']}</strong>
                      <div className="chart-wrapper">
                        <canvas id="sparkline-chart-5" width="100" height="30" />
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-2">
                    <div className="callout callout-primary">
                      <small className="text-muted">{props.localeMessage('Adgroup Settings')}</small><br/>
                      <strong className="h4">{props.summary['Adgroup Settings']}</strong>
                      <div className="chart-wrapper">
                        <canvas id="sparkline-chart-6" width="100" height="30" />
                      </div>
                    </div>
                  </div>

                </div>
                <hr className="mt-0"/>
                <BootstrapTable data={ props.list }>
                  <TableHeaderColumn dataField='Type' isKey dataFormat={typeFormatter}>
                    {props.localeMessage('Type')}
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField='settingWithLink' dataFormat={settingFormatter}>
                    {props.localeMessage('Setting')}
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField='Settings Found'>
                    {props.localeMessage('Settings Found')}
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField='Last Checked'>
                    {props.localeMessage('Last Checked')}
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
            </div>
          </div>
        </div>
      )
    };

    return (
      <div className="animated fadeIn">
        <div className="row">
          {
            Object.keys(groupedSettings).map(key => (
              <div className="col-sm-6 col-lg-4" key={key}>
                <SettingCard publisher={key}
                             ADS={groupedSettings[key].ADS}
                             SETTINGS={groupedSettings[key].SETTINGS}
                             localeMessage={text => {return this.localeMessage(text)}}/>
              </div>
            ))
          }
        </div>
        {
          Object.keys(groupedSettingsDetail).map(key => (
            <div key={key} className="row">
              <SettingDetailCard publisher={key}
                                 summary={groupedSettingsDetail[key].summary}
                                 list={groupedSettingsDetail[key].list}
                                 localeMessage={text => {return this.localeMessage(text)}}/>
            </div>
          ))
        }
      </div>
    );
  }
}

class SettingsContainer extends Component {
  render() {
    return <Settings
      {...this.props}
      {...bindActionCreators({
        ...reportsActions,
      }, this.props.dispatch)} />;
  }
}

SettingsContainer = connect(state => ({
  customers: state.reports.get('customers'),
  campaigns: state.reports.get('campaigns'),
  mcId: state.reports.get('mcId'),
  selectedLocale: state.reports.get('selectedLocale'),
  translations: state.reports.get('translations'),
}))(SettingsContainer);

export default SettingsContainer;



// WEBPACK FOOTER //
// ./src/views/Settings/Settings.js